<div class="table-processing" id="table-processing" style="display: none;">
    <span class="">Loading...&nbsp;<span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
</div>